import "./styles/app.css";
import { ProductFruits } from 'react-product-fruits';
import { LoginSocialFacebook } from "reactjs-social-login";
import Routing from "./Routes/Routing";
import { BrowserRouter } from "react-router-dom";

if (!Array.prototype.at) Array.prototype.at = function(n) { return n < 0 ? this[this.length + n] : this[n]; };
if (!Object.hasOwn) {
  Object.hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
}

function App() {
  const userInfo = {
    username: 'Admin Search Bubble', // REQUIRED - any unique user identifier
    email: 'admin@searchbubble.com',
    firstname: 'Admin',
    lastname: 'Search Bubble',
    signUpAt: '2025-04-15',
    role: 'manager',
    props: { customProp1: '==REPLACE==' }
  };

  return (
    <div className="App fullDiv">
      {/* Initialize ProductFruits */}
      <ProductFruits
        workspaceCode="md7a2flqHcsHXnfz"
        language="en"
        user={userInfo}
      />
      
      
      {/* Main routing */}
      <BrowserRouter>
        <Routing />
      </BrowserRouter>

      <LoginSocialFacebook //To load the react js social login library on app mount. Display is hidden.
        scope="instagram_basic,pages_show_list,instagram_manage_insights,pages_read_engagement"
        appId="644067177183784"
        fieldsProfile={"id,name"}
        onResolve={() => {}}
        onReject={(err) => {
        }}
        className="login-app"
      >
        Continue With Facebook
      </LoginSocialFacebook>
    </div>
  );
}

export default App;
